import { useNavigate } from "react-router-dom"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import { ImportAccountNumbersForm } from "../components/ImportAccountNumbersForm"
import { useApiMutation } from "../../../../../../core/api/useApiMutation"
import {
    COMPANY_ADMIN_DATA_IMPORT_ACCOUNT_NUMBERS_RESULT_ROUTE,
    COMPANY_ADMIN_ROUTE,
} from "../../../../../../constants/routes"
import { useCurrentCompany } from "../../../../hooks/useCurrentCompany"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import { importAccountNumbers } from "../accountNumbersApi"

export function CompanyAccountNumbers() {
    const { companyId } = useCurrentCompany()
    const navigate = useNavigate()

    const { mutate: callImportAccountNumbers } = useApiMutation(importAccountNumbers, {
        async onSuccess(_, data) {
            navigate(COMPANY_ADMIN_DATA_IMPORT_ACCOUNT_NUMBERS_RESULT_ROUTE, {
                state: { importResult: data.importResult },
            })
        },
    })

    return (
        <>
            <LocalizedStrict id="company-data-import-account-numbers-title" attrs={{ title: true }}>
                <PageHeader page={Page.COMPANY_ADMINS_DATA_IMPORT_ACCOUNT_NUMBERS} title="Import account numbers">
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="company-nav-item-home">
                            <BreadcrumbLink to={COMPANY_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="company-nav-item-data-import">
                            <Breadcrumb>Data import</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="company-nav-item-account-numbers">
                            <Breadcrumb>Account numbers</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <ImportAccountNumbersForm
                onSubmit={(dimensionId, data) => {
                    callImportAccountNumbers({ dimensionId, companyId: companyId, importData: data })
                }}
            />
        </>
    )
}
